export default "__VITE_ASSET__890d19cb__"